import React from "react";
import { Segment, Button, Image, Modal, Header } from "semantic-ui-react";
import "./Breathe.css";

class Breathe extends React.Component {
  render() {
    return (
      <Modal
        basic
        size="large"
        trigger={<Button color="green">Need some Breathing exercise?</Button>}
      >
        <Modal.Header style={{ textAlign: "center", marginTop: -100 }}>
          Breathe in when the orb squeezes and release the breath slowly as the
          orb expands [esc to quit]
        </Modal.Header>
        <div class="body">
          <div class="orb orb_1"></div>
        </div>
      </Modal>
    );
  }
}

export default Breathe;



// WEBPACK FOOTER //
// ./src/components/MetaPanel/Breathe.js